import axios from "axios";
import d3 from 'd3'
function movePage(x, y) {
    console.log(x, y);
    if (x == "forward") {
        if (y < this.offsets - 1) {
            this.curPage = this.curPage + 1;
            this.setPageoff(this.curPage, this.maxPerPage);
        } else {
            this.curPage = 0;
            this.setPageoff(this.curPage, this.maxPerPage);
        }
    } else {
        if (y > 0) {
            this.curPage = this.curPage - 1;
            this.setPageoff(this.curPage, this.maxPerPage);
        } else {
            this.curPage = this.offsets - 1;
            this.setPageoff(this.curPage, this.maxPerPage);
        }
    }
}
function getDoggyAttributes(nftid) {
    var nftid = parseInt(nftid);
    console.log(Number.isInteger(nftid));
    if (Number.isInteger(nftid)) {
        console.log("AAAAAA", nftid < 9999);
        if (nftid >= 0 && nftid <= 9999) {
            axios
                .get(
                    "https://www.bakeryswap.org/api/v2/nfts?nftType=104&offset=0&limit=50&sortName=price&sortBy=asc&onSale=-1&status=1&keyword=" +
                    nftid
                )
                .then((response) => {
                    console.log(response.data.data.list[0]);
                    this.dog = response.data.data.list[0].attributes;
                    this.dogimg = response.data.data.list[0].imageUrl;
                    this.dognftid = response.data.data.list[0].nftId;
                    this.dog["Accessory Type"] = this.dog.accessoryType;
                    this.dog["Collectible Value"] = this.dog.collectibleValue;
                    this.dog["Mint Details"] = response.data.data.list[0].blockCreateTime;
                    this.dog["Price"] =  Number(response.data.data.list[0].price).toLocaleString('en-US') + " Doggy";
                    if(this.dog['avatar']){
                        delete this.dog.avatar;
                    }
                    delete this.dog.accessoryType;
                    delete this.dog.collectibleValue;
                });
        } else {
            alert("Enter a valid ID");
        }
    } else {
        alert("Enter a valid ID");
    }
}
function setPageoff(offset, maxPerPage) {
    console.log(offset, maxPerPage);
    this.doggys = this.totaldoggys.filter(function (d, i) { return offset * maxPerPage - 1 < i && i < (offset + 1) * maxPerPage });
    console.log('insetpage', offset * maxPerPage - 1);
}
function getDoggy() {
    axios.get("https://www.bakeryswap.org/api/v2/nfts?nftType=104&offset=0&limit=0&sortName=price&sortBy=asc&onSale=1&status=1&keyword=").then((resp) => {
        var x = resp.data.data.list;
        var onsaledict = [];
        this.saleCount = resp.data.data.count;
        console.log('getDoggy');
        //console.log(resp.data.data)
        x.forEach(x => {
            if (x.nftId == "8685") {
                console.log(x);
            }
            onsaledict.push({
                imageUrl: x.imageUrl,
                nftid: x.nftId,
                accessory: x.attributes.accessory,
                accessoryType: x.attributes.accessoryType,
                breed: x.attributes.breed,
                collectibleValue: x.attributes.collectibleValue,
                color: x.attributes.color,
                rare: x.attributes.rare,
            })
        })
        console.log('x', onsaledict);
        // Doggy Type Filtering
        var myArray = onsaledict;
        this.totaldoggys = onsaledict;
        var doggyType = this.doggyType;
        if (doggyType !== null && doggyType != "null") {
            //console.log((doggyType))
            myArray = filterArray(myArray, doggyType, 'breed')
        }
        // Accessory Filter
        var accessoryName = this.accessoryName;

        if (accessoryName !== null && accessoryName != "None") {
            console.log(accessoryName);
            myArray = filterArray(myArray, accessoryName, 'accessoryType')
        }
        var collectibleValue = this.collectibleValue;
        // Collectible Value filter
        if (collectibleValue !== null && collectibleValue != "None") {
            //console.log(accessoryName);
            myArray = filterArray(myArray, collectibleValue, 'collectibleValue')
        }
        this.totaldoggys = myArray;


        if (this.totaldoggys.length - 1 > 0) {
            this.offsets = Math.ceil(this.totaldoggys.length / this.maxPerPage);
            console.log('heelo', this.totaldoggys.length, this.offsets)
            this.setPageoff(0, this.maxPerPage)
            this.curPage = 0;
        }
        else {
            this.doggys = null;
        }
        console.log('zxxz', this.totaldoggys);
        // Doggy Accessory Filtering
    })
}
function filterArray(arrayToFilter, filterCondtion, attribute) {
    console.log('filterCondtion', filterCondtion);
    if (isInt(parseInt(filterCondtion))) {
        var filterCondtion = parseInt(filterCondtion);
        return arrayToFilter.filter((el) => {
            return parseInt(filterCondtion) == parseInt(el[attribute])
        });
    } else {
        return arrayToFilter.filter(function (el) {
            return filterCondtion.includes(el[attribute]);
        });
    }
}
function isInt(value) {
    var x;
    return isNaN(value) ? !1 : (x = parseFloat(value), (0 | x) === x);
}
export { movePage, getDoggyAttributes, getDoggy, filterArray, setPageoff }